(function() {
    angular
        .module("app")
        .controller("HeaderController", HeaderController)

    HeaderController.$inject = [
        "$state",
        "$rootScope",
        "$scope",
        "$uibModal",
        "prefs",
        "userMessagingService",
        "authenticationService",
        "alertsService",
        "customersService",
        "wzService",
        "noticeService"
    ]

    function HeaderController(
        $state,
        $rootScope,
        $scope,
        $uibModal,
        prefs,
        userMessagingService,
        authenticationService,
        alertsService,
        customersService,
        wzService,
        noticeService
    ){
        "use strict"

        const SEARCH_TYPE_STARTS_WITH = 0
        const SEARCH_TYPE_FULL_TEXT   = 1
        const ANIMATION_TIMING        = 165

        $scope.showAlerts         = false
        $scope.willShowCustomers  = false
        $scope.headerCustomers    = []
        $scope.selectedCustomer   = {}
        $scope.customerSearchType = prefs.get().customers.searchType
        $scope.hasOneTopCustomer  = true
        $scope.showSearchClose    = false
        $scope.showZZCabCustomers = false
        $scope.zzcabCustomers     = []
        $scope.zz = {
            selectedID: undefined
        }

        let customerSearchTerm       = ""
        let allowMouseHighlight      = true
        let preventCustomerListClose = true
        let initializationComplete   = false
        let preventBodyScrollClose   = true
        let allowMouseHighlightTimer
        let currentHightlightCustomer

        const isDefined = (value) => {
            return value !== undefined && value !== null
        }
        $scope.isDefined = isDefined

        const getCustomerListElement = () => {
            return document.getElementById("customerDropdownList")
        }

        const getCustomerDropdownContainerElement = () => {
            return document.getElementById("customerDropdownContainer")
        }

        const getCustomerDropdownMenuElement = () => {
            return document.getElementById("customerDropdownMenu")
        }

        const getCustomerListItemElement = (id) => {
            return document.getElementById(id)
        }

        const getCustomerSearchElement = () => {
            return document.getElementById("customerDropdownSearch")
        }

        const getCustomerDropdownFilterElement = () => {
            return document.getElementById("customerDropdownFilter")
        }

        const getBodyElement = () => {
            return document.getElementById("mainBody")
        }

        const focusCustomerSearch = () => {

            const customerSearchElement = getCustomerSearchElement()

            if (!isDefined(customerSearchElement)) {
                console.error("[CustomerDropdown].focusCustomerSearch() -> Customer Search Element Not Found")
                return
            }

            customerSearchElement.focus()

        }

        const clearCustomerSearch = () => {

            const customerSearchElement = getCustomerSearchElement()

            if (!isDefined(customerSearchElement)) {
                console.error("[CustomerDropdown].clearCustomerSearch() -> Customer Search Element Not Found")
                return
            }

            customerSearchElement.value = ""
            filterCustomerList()

        }

        const initialize = () => {

            if (!initializationComplete) {

                //
                // Animation Only
                //

                // const customerDropdownMenuElement = getCustomerDropdownMenuElement()

                // if (customerDropdownMenuElement) {

                //     $("#customerDropdownContainer").on("hide.bs.dropdown", (_event) => {

                //         if (preventCustomerListClose) {
                //             return false
                //         }

                //         customerDropdownMenuElement.classList.add("fade-out")

                //         setTimeout(() => {
                //             customerDropdownMenuElement.classList.remove("fade-out")
                //         }, 100)
                //     })

                //     $("#customerDropdownContainer").on("show.bs.dropdown", (_event) => {

                //         customerDropdownMenuElement.classList.add("fade-in")

                //         setTimeout(() => {
                //             customerDropdownMenuElement.classList.remove("fade-in")
                //         }, 100)
                //     })

                //     initializationComplete = true

                // }

                const customerDropdownContainerElement = getCustomerDropdownContainerElement()
                const customerDropdownMenuElement      = getCustomerDropdownMenuElement()
                const customerDropdownListElement      = getCustomerListElement()
                const customerDropdownSearchElement    = getCustomerSearchElement()
                const customerDropdownFilterElement    = getCustomerDropdownFilterElement()
                const bodyElement                      = getBodyElement()

                if (!isDefined(customerDropdownContainerElement)) { return }
                if (!isDefined(customerDropdownMenuElement))      { return }
                if (!isDefined(customerDropdownListElement))      { return }
                if (!isDefined(customerDropdownSearchElement))    { return }
                if (!isDefined(customerDropdownFilterElement))    { return }
                if (!isDefined(bodyElement))                      { return }

                initializationComplete = true

                $("#customerDropdownContainer").on("hide.bs.dropdown", (_event) => {

                    if (preventCustomerListClose) {
                        return false
                    }

                })

                $("#customerDropdownContainer").on("show.bs.dropdown", (_event) => {

                    customerDropdownMenuElement.classList.add("fade-in")

                    setTimeout(() => {
                        customerDropdownMenuElement.classList.remove("fade-in")
                    }, ANIMATION_TIMING)
                })

                customerDropdownContainerElement.addEventListener("mouseover", (_event) => {

                    preventBodyScrollClose = true

                })

                customerDropdownContainerElement.addEventListener("mouseout", (_event) => {

                    preventBodyScrollClose = false

                })

                customerDropdownSearchElement.addEventListener("wheel", (event) => {

                    event.stopPropagation()
                    event.preventDefault()

                })

                customerDropdownFilterElement.addEventListener("wheel", (event) => {

                    event.stopPropagation()
                    event.preventDefault()

                })

                customerDropdownMenuElement.addEventListener("wheel", (event) => {

                    event.stopPropagation()

                    const displayedCustomersCount = $scope.headerCustomers.filter((c) => { return c.menuDisplay.showInList }).length
                    const possibleDisplayHeight   = (displayedCustomersCount * 41) - 1
                    const menuDisplayHeight       = customerDropdownListElement.clientHeight
                    const scrollPosition          = customerDropdownListElement.scrollTop

                    const scrollDown    = event.deltaY >= 0
                    const scrollUp      = !scrollDown
                    const atTop         = scrollPosition <= 0
                    const atBottom      = scrollPosition + menuDisplayHeight >= possibleDisplayHeight - 5 // Chrome Windows is 5 pixels off
                    const notScrollable = possibleDisplayHeight >= menuDisplayHeight - 4 && possibleDisplayHeight <= menuDisplayHeight + 4

                    if (notScrollable || (scrollUp && atTop) || (scrollDown && atBottom)) {
                        event.preventDefault()
                    }
                })

                bodyElement.addEventListener("wheel", (event) => {

                    if (!preventBodyScrollClose) {

                        preventBodyScrollClose = true

                        const customerSearchElement = getCustomerSearchElement()

                        if (isDefined(customerSearchElement)) {
                            customerSearchElement.blur()
                        }
                    }

                }, { passive: false })

            }
        }

        const scrollToCustomer = (toCustomer, center) => {

            const customerListElement = getCustomerListElement()

            if (!isDefined(customerListElement)) {
                console.error("[CustomerDropdown].scrollToCustomer() -> Customer List Element Not Found")
                return
            }

            const customerListElementRect = customerListElement.getBoundingClientRect()

            if (toCustomer) {

                const firstCustomerElement = getCustomerListItemElement("customerDropdownListItem-" + toCustomer.id + "-" + toCustomer.menuDisplay.level)

                if (!isDefined(firstCustomerElement)) {
                    if (!$scope.showNoCustomers) {
                        console.error("[CustomerDropdown].scrollToCustomer() -> Customer List Item Element Not Found")
                    }
                    return
                }

                const firstCustomerElementRect = firstCustomerElement.getBoundingClientRect()

                currentHightlightCustomer = toCustomer

                for (const customer of $scope.headerCustomers) {
                    customer.menuDisplay.highlighted = false
                }

                toCustomer.menuDisplay.highlighted = true

                const isViewable = (firstCustomerElementRect.top >= customerListElementRect.top) && (firstCustomerElementRect.bottom <= customerListElementRect.bottom)

                if (!isViewable) {

                    if (center) {
                        customerListElement.scrollTop = firstCustomerElementRect.top - (customerListElementRect.height / 2) - (firstCustomerElementRect.height * 1.5)
                        return
                    }

                    const scrollTop = firstCustomerElementRect.top - customerListElementRect.top;
                    const scrollBot = firstCustomerElementRect.bottom - customerListElementRect.bottom;

                    if (Math.abs(scrollTop) < Math.abs(scrollBot)) {
                        // Near top of list
                        customerListElement.scrollTo({
                            top: customerListElement.scrollTop + scrollTop,
                            behavior: "instant"
                        })

                    } else {
                        // Near bottom of list
                        customerListElement.scrollTo({
                            top: customerListElement.scrollTop + scrollBot,
                            behavior: "instant"
                        })
                    }
                }
            }
        }

        const processCustomers = (customerList) => {

            if (customerList.length === 0) {
                $scope.headerCustomers = []
                return
            }

            // Remove existing Angular $$hashKey, menuDisplay and subs, which exist on $rootScope.customers after having created or deleted a customer

            customerList.map((c) => { delete c.$$hashKey; delete c.menuDisplay; delete c.subs })

            $scope.zzcabCustomers = []

            // Segment out ZZ-CAB- customers
            // Add children to parent.subs array

            for (const sub of customerList) {

                if (!isDefined(sub.parent_id)) { continue }

                if (sub.name.startsWith("ZZ-CAB-")) {
                    $scope.zzcabCustomers.push(sub)
                    continue
                }

                for (const customer of customerList) {

                    if (customer.id === sub.parent_id) {

                        if (!isDefined(customer.subs)) {
                            customer.subs = []
                        }

                        customer.subs.push(sub)
                        break

                    }
                }
            }

            // Remove children from top level (they're now only in parent.subs), unless it is current users customer

            customerList = customerList.filter((c) => { return !isDefined(c.parent_id) || c.id === $rootScope.user.customer_id })

            $scope.hasOneTopCustomer = customerList.length === 1

            const _updateAllCustomers = (level, _customers) => {

                let customers = []

                for (const customer of _customers) {

                    customers.push({
                        ...customer,
                        menuDisplay: {
                            showInList:  true,
                            expanded:    false,
                            highlighted: false,
                            selected:    $rootScope.selectedCustomerID === customer.id,
                            level:       0
                        }
                    })

                    if (level > 0) {

                        customers.push({
                            ...customer,
                            menuDisplay: {
                                showInList:  false,
                                expanded:    false,
                                highlighted: false,
                                selected:    false,
                                level:       level
                            }
                        })
                    }

                    if (customer.subs && customer.subs.length > 0) {

                        customers = customers.concat(_updateAllCustomers(level + 1, customer.subs))

                    }
                }

                return customers

            }

            let customers = _updateAllCustomers(0, customerList)

            const levelZeroCustomers = customers.filter((c) => { return c.menuDisplay.level === 0 }).sort((a, b) => { return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1 })
            const levelPlusCustomers = customers.filter((c) => { return c.menuDisplay.level   > 0 }).sort((a, b) => { return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1 })

            const _nestLevelPlusCustomers = (parent) => {

                let customers = []

                // Only nest sub-customers within Top Level customer branch

                if (parent.subs && parent.subs.length > 0 && (!parent.menuDisplay.showInList || !isDefined(parent.parent_id) || parent.id === $rootScope.user.customer_id)) {

                    for (let i = 0; i < levelPlusCustomers.length; i += 1) {

                        const nestedCustomer = levelPlusCustomers[i]

                        if (nestedCustomer && nestedCustomer.parent_id === parent.id) {

                            levelPlusCustomers[i] = undefined

                            customers.push(nestedCustomer)
                            customers = customers.concat(_nestLevelPlusCustomers(nestedCustomer))

                        }
                    }
                }

                return customers

            }

            customers = []

            for (const zeroCustomer of levelZeroCustomers) {
                customers.push(zeroCustomer)
                customers = customers.concat(_nestLevelPlusCustomers(zeroCustomer))
            }

            if ($scope.hasOneTopCustomer) {

                let _customers = []

                for (const customer of customers) {

                    customer.menuDisplay.showInList = true
                    customer.menuDisplay.expanded   = true

                    if (!isDefined(customer.parent_id) || customer.id === $rootScope.user.customer_id) {
                        _customers.unshift(customer)
                        continue
                    }

                    if (customer.menuDisplay.level > 0) {
                        _customers.push(customer)
                    }
                }

                customers = _customers
            }

            for (const customer of customers) {

                let foundSelected = false
                let foundSelf     = false

                if (!foundSelected && customer.menuDisplay.showInList && customer.id === $rootScope.selectedCustomerID) {

                    $scope.selectedCustomer   = customer
                    currentHightlightCustomer = customer
                    foundSelected = true

                }

                if (!foundSelf && customer.id === $rootScope.user.customer_id) {

                    $rootScope.hasApiAccess    = customer.api.enabled
                    $rootScope.hasWZDxFFAccess = customer.wzdx.enabled

                    if (customer.api.enabled) {
                        $rootScope.apiConfigID = customer.api.config.id
                    }

                    if (customer.wzdx.enabled) {
                        $rootScope.wzdxConfigID = customer.wzdx.config.id
                    }

                    foundSelf = true

                }

                if (foundSelected && foundSelf) {
                    break
                }
            }

            $scope.headerCustomers = customers

        }

        const filterCustomerList = (viaValueAlteringKey) => {

            const customerSearchElement = getCustomerSearchElement()

            if (!isDefined(customerSearchElement)) {
                console.error("[CustomerDropdown].filterCustomerList() -> Customer Search Element Not Found")
                return
            }

            customerSearchTerm = customerSearchElement.value.toLowerCase()

            let hasAnyCustomers = false

            for (const customer of $scope.headerCustomers) {

                customer.menuDisplay.showInList = false

                if (customerSearchTerm.trim() === "") {

                    hasAnyCustomers = true
                    customer.menuDisplay.showInList = $scope.hasOneTopCustomer || customer.menuDisplay.level === 0

                } else if (($scope.customerSearchType === SEARCH_TYPE_STARTS_WITH && customer.name.toLowerCase().startsWith(customerSearchTerm)) || ($scope.customerSearchType === SEARCH_TYPE_FULL_TEXT && customer.name.toLowerCase().contains(customerSearchTerm))) {

                    customer.menuDisplay.showInList = $scope.hasOneTopCustomer || customer.menuDisplay.level === 0
                    hasAnyCustomers = true

                }
            }

            if (!hasAnyCustomers) {
                $scope.showNoCustomers = true
                return
            }

            $scope.showNoCustomers = false

            if ($scope.hasOneTopCustomer) {

                // Show Parents if Customer is Matched

                const showParent = (customer) => {

                    for (const c of $scope.headerCustomers) {

                        if (c.id === customer.parent_id) {

                            c.menuDisplay.showInList = true

                            if (c.parent_id) {
                                showParent(c)
                            }
                        }
                    }
                }

                for (const customer of $scope.headerCustomers) {

                    if (customer.menuDisplay.showInList && customer.parent_id) {

                        showParent(customer)

                    }
                }

            } else {

                // Show Nested Customers if Matched Customer is Expanded

                for (const customer of $scope.headerCustomers) {

                    if (customer.menuDisplay.expanded && customer.menuDisplay.showInList) {

                        for (const c of $scope.headerCustomers) {
                            if (c.menuDisplay.level === customer.menuDisplay.level + 1 && c.parent_id === customer.id) {
                                c.menuDisplay.showInList = true
                            }
                        }
                    }
                }
            }

            if (viaValueAlteringKey) {

                // Scroll to top and highlight first customer

                let firstCustomer

                for (const customer of $scope.headerCustomers) {
                    if (!isDefined(firstCustomer) && customer.menuDisplay.showInList) {
                        firstCustomer = customer
                    }
                    customer.menuDisplay.highlighted = false
                }

                if (firstCustomer) {
                    firstCustomer.menuDisplay.highlighted = true
                    currentHightlightCustomer = firstCustomer
                }

                const customerListElement = getCustomerListElement()

                if (!isDefined(customerListElement)) {
                    console.error("[CustomerDropdown].filterCustomerList() -> Customer List Element Not Found")
                    return
                }

                customerListElement.scrollTo({
                    top: 0,
                    behavior: "instant"
                })

            }
        }

        $scope.logout = () => {
            authenticationService.logout()
        }

        $scope.openCreateWzModal = () => {

            $uibModal.open({
                templateUrl: "app/modals/wz-create-modal.view.html",
                controller: "WzCreateModalController",
                windowClass: "wzCreateModal",
                resolve: {
                    success: () => {
                        return (data) => {
                            if (data && data.type) {
                                if (data.type === "QWS") {
                                    $state.go("wz.configuration-qws", { wz_id: data.id })
                                } else {
                                    $state.go("wz.configuration-se", { wz_id: data.id })
                                }
                            }
                        }
                    },
                    failure: () => {
                        return (error) => {
                            userMessagingService.error("Failed to Create Work Zone: " + error)
                        }
                    }
                }
            }).result.catch((res) => {
                if (!(res === "cancel" || res === "escape key press")) {
                    throw res
                }
            })
        }

        $scope.shouldShowCustomers = () => {
            $scope.willShowCustomers = isDefined($scope.headerCustomers) && $scope.headerCustomers.length > 1 && $rootScope.can('CustomerRead', $rootScope.user.customer_id)
            return $scope.willShowCustomers
        }

        $scope.highlightCustomer = (customer, highlight) => {

            if (!allowMouseHighlight) { return }

            for (const customer of $scope.headerCustomers) {
                customer.menuDisplay.highlighted = false
            }

            if (highlight) {
                customer.menuDisplay.highlighted = true
                currentHightlightCustomer = customer
            }
        }

        $scope.showCustomerList = () => {

            initialize()

            preventBodyScrollClose   = true
            preventCustomerListClose = true

            setTimeout(() => {

                preventCustomerListClose = false

                $scope.$apply(() => {
                    scrollToCustomer(currentHightlightCustomer, true)
                })

            }, 1)

            focusCustomerSearch()

        }

        $scope.preventCustomerSearchInputBlur = (event) => {

            if (isDefined(event)) {

                event.preventDefault()
                event.stopPropagation()

            }
        }

        $scope.clearOrHideCustomerDropdown = (event) => {

            const customerSearchElement = getCustomerSearchElement()

            if (!isDefined(customerSearchElement)) {
                console.error("[CustomerDropdown].clearOrHideCustomerDropdown() -> Customer Search Element Not Found")
                return
            }

            if (customerSearchElement.value === "") {

                if (isDefined(event)) {
                    event.stopPropagation()
                }

                customerSearchElement.blur()

                return

            }

            clearCustomerSearch()
            focusCustomerSearch()

        }

        $scope.handleCustomerSearchInputFocus = () => {

            const customerSearchElement = getCustomerSearchElement()

            if (isDefined(customerSearchElement)) {
                customerSearchElement.placeholder = "Search ..."
            }
        }

        $scope.handleCustomerSearchInputBlur = () => {

            const customerSearchElement       = getCustomerSearchElement()
            const customerDropdownMenuElement = getCustomerDropdownMenuElement()
            const body                        = getBodyElement()

            if (isDefined(customerSearchElement)) {
                customerSearchElement.placeholder = "Select Account ..."
            }

            if (isDefined(customerDropdownMenuElement)) {

                customerDropdownMenuElement.classList.add("fade-out")

                setTimeout(() => {
                    customerDropdownMenuElement.classList.remove("fade-out")
                }, ANIMATION_TIMING)
            }

            if (isDefined(body)) {

                setTimeout(() => {
                    body.click()
                }, ANIMATION_TIMING)
            }
        }

        $scope.handleCustomerSearchInputKeyDown = (event) => {

            if (!isDefined(event)) {
                console.error("[CustomerDropdown].handleCustomerSearchInputKeyDown() -> Missing Event")
                return
            }

            // Handler for Key Down (including hold-down repeat)

            if (event.key === "ArrowDown" || event.key === "ArrowUp") {

                $scope.handleCustomerSearchInputKeyUp({ key: event.key + "-Flagged" })
                event.preventDefault()

            } else if (event.key === "Enter") {

                if (currentHightlightCustomer) {
                    $scope.viewCustomer(currentHightlightCustomer)
                }

            } else if ((event.metaKey || event.ctrlKey) && (event.key === "v" || event.key === "x")) {

                // Paste or Cut
                // Must be delayed for event to complete (paste or cut action to complete)

                setTimeout(() => {
                    $scope.$apply(() => {
                        $scope.handleCustomerSearchInputKeyUp()
                    })
                }, 50)

            }
        }

        const allowedCustomerSearchInputKeys = [
            "Backspace",
            "Delete",
            "Unidentified"
        ]

        $scope.handleCustomerSearchInputKeyUp = (event) => {

            if (!isDefined(event)) {
                console.error("[CustomerDropdown].handleCustomerSearchInputKeyUp() -> Missing Event")
                return
            }

            // Handler for Key Up

            if (!isDefined(event.key) || event.key.length === 1 || allowedCustomerSearchInputKeys.contains(event.key)) {

                // if event.key === "Unidentified":
                //
                // 2025-01-19
                // Chrome on Android software keyboard does not send valid event.key data
                //
                // Long standing Chrome bug:
                // https://issues.chromium.org/issues/41443178
                //
                // Other information:
                // https://stackoverflow.com/questions/36753548/keycode-on-android-is-always-229
                // https://stackoverflow.com/questions/59584061/why-is-unidentified-returned-on-keyboard-input-on-mobile
                // https://clark.engineering/input-on-android-229-unidentified-1d92105b9a04

                filterCustomerList(true) // Input value altering key was pressed (viaValueAlteringKey)
                return

            }

            if (event.key === "ArrowDown-Flagged" || event.key === "ArrowUp-Flagged") {

                allowMouseHighlight = false

                clearTimeout(allowMouseHighlightTimer)

                allowMouseHighlightTimer = setTimeout(() => {
                    allowMouseHighlight = true
                }, 1000)

                let customers = $scope.headerCustomers.filter((c) => { return c.menuDisplay.showInList })

                if (event.key === "ArrowUp-Flagged") {
                    customers = customers.reverse()
                }

                let nextCustomerIdx = 0

                if (currentHightlightCustomer) {

                    const currentHightlightCustomerIdx = customers.indexOf(currentHightlightCustomer)

                    if (currentHightlightCustomerIdx < customers.length - 1) {
                        nextCustomerIdx = currentHightlightCustomerIdx + 1
                    }
                }

                let nextCustomer = customers[nextCustomerIdx]

                if (nextCustomer.menuDisplay.selected) {

                    nextCustomerIdx += 1

                    if (nextCustomerIdx >= customers.length) {
                        nextCustomerIdx = 0
                    }

                    nextCustomer = customers[nextCustomerIdx]

                    // Again in case next customer is selected sub customer

                    if (nextCustomer.menuDisplay.selected) {

                        nextCustomerIdx += 1

                        if (nextCustomerIdx >= customers.length) {
                            nextCustomerIdx = 0
                        }

                        nextCustomer = customers[nextCustomerIdx]

                    }
                }

                currentHightlightCustomer = nextCustomer
                scrollToCustomer(nextCustomer)
                filterCustomerList()

            }
        }

        $scope.expandCustomer = (customer, event) => {

            if (event) {
                event.stopPropagation() // Prevent selecting Customer
            }

            customer.menuDisplay.expanded = !customer.menuDisplay.expanded
            filterCustomerList()
            focusCustomerSearch()

        }

        $scope.setCustomerSearchType = (newType, event) => {

            if (event) {
                event.preventDefault()
                event.stopPropagation()
            }

            focusCustomerSearch()

            if (newType !== $scope.customerSearchType) {

                prefs.set(prefs.selectors().customers.searchType, newType)

                // Direct click on radio button won't update display, unless this is pulled off current thread

                setTimeout(() => {
                    $scope.$apply(() => {
                        $scope.customerSearchType = newType
                        filterCustomerList(true)
                    })
                }, 1)
            }
        }

        $scope.viewCustomer = (customer, event) => {

            if (event) {
                event.stopPropagation()
            }

            if (!isDefined(customer) || customer.id === $scope.selectedCustomer.id) {
                focusCustomerSearch()
                return
            }

            $scope.zz.selectedID          = undefined
            $rootScope.selectedZZCabID    = undefined
            $rootScope.selectedCustomerID = customer.id
            gtag("set", { target_customer: customer.name })

            wzService.listAll($rootScope.selectedCustomerID).then((data) => {
                $rootScope.wzs = data
            })

            const customerSearchElement = getCustomerSearchElement()

            if (isDefined(customerSearchElement)) {
                customerSearchElement.blur()
            }

            clearCustomerSearch()

            $state.go("devices", null, { reload: true })

        }

        $scope.viewZZCab = () => {

            $rootScope.selectedZZCabID = undefined

            if (isDefined($scope.zz.selectedID)) {
                $rootScope.selectedZZCabID = $scope.zz.selectedID
            }

            $state.go("devices", null, { reload: true })
            clearCustomerSearch()

        }

        $scope.$watch("$root.customers", () => {
            processCustomers($rootScope.customers)
            $scope.shouldShowCustomers()
        })

        $scope.$watch("$root.is_authenticated", () => {

            $scope.willShowCustomers = false

            if ($rootScope.is_authenticated) {

                    $(document).on("shown.bs.dropdown", (event) => {

                        if (isDefined(event.target) && event.target.id === "customerDropdownContainer") {

                            setTimeout(() => {
                                $scope.$apply(() => {
                                    $scope.showSearchClose = true
                                })
                            }, 1)
                        }
                    })

                    $(document).on("hidden.bs.dropdown", (event) => {

                        if (isDefined(event.target) && event.target.id === "customerDropdownContainer") {

                            setTimeout(() => {
                                $scope.$apply(() => {
                                    $scope.showSearchClose = false
                                })
                            }, 1)
                        }
                    })

                if (window.location.href.indexOf("/api/configs/") > 0 && window.location.href.indexOf("/documentation") > window.location.href.indexOf("/api/configs/")) {
                    return
                }

                alertsService.getAlertCount().then((data) => {
                    if (isDefined(data)) {
                        $rootScope.alertCount = data.alerts
                    }
                })

                wzService.listAll($rootScope.selectedCustomerID).then((data) => {
                    $rootScope.wzs = data
                })

                customersService.getCustomers((data) => {
                    $rootScope.customers = data
                })
            }
        })

        $scope.$watch("$root.selectedCustomerID", () => {

            if ($rootScope.selectedCustomerID !== $scope.selectedCustomer.id) {

                let foundMenuCustomer

                for (const customer of $scope.headerCustomers) {

                    customer.menuDisplay.selected = false

                    if (customer.id === $rootScope.selectedCustomerID) {

                        customer.menuDisplay.selected = true

                        if (customer.menuDisplay.level === 0) {
                            foundMenuCustomer = customer
                        } else if (!isDefined(foundMenuCustomer)) {
                            foundMenuCustomer = customer
                        }
                    }
                }

                if (foundMenuCustomer) {
                    $scope.selectedCustomer = foundMenuCustomer
                }

                // Handle ZZ CAB

                $scope.showZZCabCustomers = false

                if ($scope.selectedCustomer.name === "ZZ-CAB") {

                    $scope.showZZCabCustomers = true

                }
            }
        })

        $scope.$watch("$root.displayNotice", () => {

            if (isDefined($rootScope.displayNotice)) {

                $uibModal.open({
                    templateUrl: "app/modals/notice-modal.view.html",
                    controller: "NoticeModalController",
                    windowClass: "noticeModal",
                    resolve: {
                        previewNotice: () => {
                            return undefined
                        },
                        emailNotice: () => {
                            return (noticeID) => {

                                const finish = () => {
                                    $rootScope.displayNotice = undefined
                                }

                                noticeService.emailNotice(noticeID, finish, (error) => {
                                    console.error(error)
                                    finish()
                                })
                            }
                        },
                        markNoticeAsRead: () => {
                            return (noticeID) => {

                                const finish = () => {
                                    $rootScope.displayNotice = undefined
                                }

                                noticeService.markNotice(noticeID, true, finish, (error) => {
                                    console.error(error)
                                    finish()
                                })
                            }
                        }
                    }
                }).result.catch((res) => {
                    if (!(res === "cancel" || res === "escape key press")) {
                        throw res
                    }
                })
            }
        })
    }
})()
